import { Dic } from '$utils'
export const moreFilterOption = function(that) {
  return {
    menuBtn: false,
    labelWidth: 82,
    labelPosition: 'left',
    gutter: 10,
    size: 'mini',
    column: [
      {
        label: that.$t('historyAlarm.title.alarmLevel'),
        prop: 'alarmLevel',
        type: 'checkbox',
        formslot: true,
        span: 24
      },
      {
        label: '告警子系统',
        prop: 'subSystem',
        type: 'checkbox',
        formslot: true,
        span: 24
      },
      {
        label: that.$t('historyAlarm.title.alarmType'),
        prop: 'alarmType',
        type: 'checkbox',
        formslot: true,
        dicData: [{ label: that.$t('historyAlarm.label.whole'), value: '' }].concat(Dic.find('SENU004005')),
        span: 24
      }
    ]
  }
}
